import React from 'react';

import { Link as LinkIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { appRoutes, RouterEntitiesId } from '@clearverify/constants';

import { CompanyType } from 'src/api';
import { DetailPageLayout } from 'src/components/common';
import { EmployeeDataSearchScreen } from 'src/components/employee';
import {
  useCopyEmployeeInviteLink,
  useEmployeeDataSearch,
  useResendEmployeeInvite,
} from 'src/hooks/employee';
import { usePeoPayrollProviderParamId } from 'src/hooks/peoPayrollProvider';

export const PeoPayrollProviderDetailEmployeesPage: React.FC = () => {
  const peoPayrollProviderId = usePeoPayrollProviderParamId();
  const search = useEmployeeDataSearch({
    scope: 'admin',
    skip: !peoPayrollProviderId,
    companyFilter: peoPayrollProviderId
      ? { companyType: CompanyType.PeoPayrollProvider, companyId: peoPayrollProviderId }
      : undefined,
  });

  const inviteLinkArgs = {
    route: appRoutes.auth.signupEmployeePeoPayrollProvider,
    paramKey: RouterEntitiesId.peoPayrollProvider,
    entityId: peoPayrollProviderId,
  };
  const copyInviteLink = useCopyEmployeeInviteLink(inviteLinkArgs);
  const resendInvite = useResendEmployeeInvite('cvStaff');

  return (
    <DetailPageLayout
      titleContent="Employees"
      topRightContent={
        <Button startIcon={<LinkIcon />} onClick={copyInviteLink}>
          Copy signup link
        </Button>
      }
    >
      <EmployeeDataSearchScreen
        {...search}
        allowEmailSearch
        enableAdminControls
        inviteLinkArgs={inviteLinkArgs}
        inviteEmailOptionsScope="admin"
        sendInviteScope="cvStaff"
        onResendInvite={resendInvite}
      />
    </DetailPageLayout>
  );
};
